import { Theme, colorGradients } from "./theme-types"

const primary = '#012427'

const climateFirstBankTheme: Theme = {
  name: 'climateFirst',
  dark: false,
  colors: {
    primary: primary,

    // background colors
    bgMain: '#ffffff',
    bgSecond: "#ededed",
    bgAlt: '#242A34',

    // button colors
    buttonAlt: '#459BA0',

    // text colors
    textMain: '#000000',
    textSecond: '#0B1B2B',
    textAlt: colorGradients.gray[700],
    placeholder: '#aaaaaa',

    // state colors
    success: "#1DCC70",
    danger: "#FF396F",
    warning: "#FFB400",
    info: "#05D0A4",
    disabled: "#D2D2D2",

    // border colors
    borderColor: "#DCDCE9",
    shadowColor: "#171717", // Keep current shadow for light mode

    // transactions
    bgTransaction: "#ffffff",

    // navigation
    statusBarStyle: 'dark',
    tabBackground: '#fff',
    tabInactiveText: colorGradients.blue[300],
    tabActiveText: '#fff',
    headerBackground: primary,
    headerText: '#ffffff',
    footerBackground: primary,

    // loading animation colors
    loadingAnimation: {
      color1: primary,
      color2: "#9fd4bc",
      color3: "#e68a40",
    },
    skeletonLoader: '#DDE4EC',

    // scrollbar colors
    scrollbarThumb: '#707070',

    // extra palette colors
    second: "#8494A8",
    dark: "#222222",
    darkAccent: "#0C359E",
    lightAccent: "#5356FF",
    white: '#ffffff',

    ...colorGradients,
  }
}

export default climateFirstBankTheme
